import apiClient from './apiClient'

// The backend has no per-field theme endpoints anymore: read the theme, then PUT the whole
// object (read-modify-write). fontStyle/buttonStyle are enum NAME strings ("FILLED_ROUND");
// colors are hex without '#'.

export async function getThemeById(themeId) {
    const { data } = await apiClient.get(`/themes/${themeId}`)
    return data
}

/** Full-object update; returns the updated theme. */
export async function updateTheme(themeId, themeInput) {
    const { data } = await apiClient.put(`/themes/${themeId}`, themeInput)
    return data
}

/** Creates a theme for a page (the backend links it to the page). */
export async function createThemeForPage(pageId, themeInput) {
    const { data } = await apiClient.post(`/themes/${pageId}`, themeInput)
    return data
}
